import { createAction } from 'typesafe-actions'

export type PriceMode = 'full' | 'rate'

export const changePriceMode = createAction('CMD / PriceMode / change')<PriceMode>()
